import type { ReactNode } from 'react';

export const withTestId = (id: string) => (children: ReactNode) =>
  <div data-testid={id}>{children}</div>;
